var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    fillRule: "evenodd",
    d: "M.093.58A1 1 0 0 1 1 0h20a1 1 0 0 1 .764 1.646L14 10.826V19a1 1 0 0 1-1.447.894l-4-2A1 1 0 0 1 8 17v-6.174L.236 1.646A1 1 0 0 1 .093.579M3.155 2l6.609 7.814a1 1 0 0 1 .236.646v5.922l2 1V10.46a1 1 0 0 1 .236-.646L18.845 2z",
    clipRule: "evenodd"
  })));
};
export default SvgFilter;